
import type { AxiosRequestConfig } from 'axios';
import { post } from '@/utils/network/axios-helper';
import { EXAM_REQUEST_TIMEOUT_MS } from '@/utils/network/examRequest';
import type { IParamsType, ISudentInfo } from '@/utils/ctype';

export { EXAM_REQUEST_TIMEOUT_MS } from '@/utils/network/examRequest';

export interface IItem{
  course: string;
  is_confirm: number;
  score: number;
  status: number;
  update_time: number;
  // Missing for older API responses, so status=3 alone is not a safe completion signal.
  submission_pending?: boolean;
}

export interface IGetExamInfo {
  listening: IItem;
  reading: IItem;
  writing:IItem;
  record_id: number;
  type: number;
}

export const getExamInfo = async (params?: IParamsType, config?: AxiosRequestConfig) => {
  return post<IGetExamInfo>('/api/simulate/get-exam-info', params, {
    timeout: EXAM_REQUEST_TIMEOUT_MS,
    ...config,
  });
};

export const getStudentInfo = async () => {
  return post<ISudentInfo>('/api/student/get-info', {});
};
